"use strict";
window._theme = window._theme || {};
document.addEventListener('DOMContentLoaded',function(){
    
    _theme.initSlickSlider($('.trending-articles-slider'),{
        infinite : false,
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
    
        {
            breakpoint: 1199,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 4
            }
        },
        {
            breakpoint: 992,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2
            }
        },
            {
            breakpoint: 480,
            settings: {
                slidesToShow: 1.3,
                slidesToScroll: 1
            }
            }
        ]
    })
});